/* eslint-disable max-len */
export const UNAVAILABLE_IMAGE = 'Unavailable image';
export const ITEM_DESCRIPTION_UNAVAILABLE = 'Item Description Unavailable';

export const ALERT_MESSAGES = {
  ITEMS_IN_PROGRESS_ERROR_TITLE: 'Items In Progress Not Available',
  ITEMS_IN_PROGRESS_ERROR_MESSAGE: 'Something went wrong on our end. Please check back later.',
  ORDER_STATUS_UNAVAILABLE: 'Order status unavailable',
  PRODUCT_DETAILS_UNAVAILABLE: 'Product details unavailable',
  SHIPMENT_DETAILS_UNAVAILABLE: 'We were unable to retrieve your shipment details. Refresh the page and try again.',
  ORDER_DETAILS_UNAVAILABLE: 'We were unable to retrieve your order details. Refresh the page and try again.',
  PICKUP_LOCKER_QR_CODE_ERROR: 'Looks like we had a technical issue. Visit the help desk at your pickup location to retrieve your item(s).'
};
